import React, { useState, useEffect } from 'react';
import { showErrorAlert } from '../../../../utils/alerts';
import { getEventOpenDoorDetailsByBuildingId } from '../../../../utils/services/eventService';
import EventOpenDoorList from './EventOpenDoorList';
import PropTypes from 'prop-types';
import { Pagination, PaginationItem, PaginationLink } from 'reactstrap';

const EventOpenDoorMonitor = ({ match }) => {
  const [eventOpenDoors, setEventOpenDoors] = useState([]);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  const buildingId = match?.params?.buildingId;

  const getEventOpenDoors = async () => {
    try {
      const response = await getEventOpenDoorDetailsByBuildingId(buildingId, {
        page,
        limit: 40,
      });

      setEventOpenDoors(response?.eventOpenDoorDetails || []);
      setTotalPages(response?.totalPages || 1);
    } catch (error) {
      console.error('Error al obtener eventos', error);
      showErrorAlert('Error', error.message || 'No se pudieron obtener los eventos.');
    }
  };

  useEffect(() => {
    getEventOpenDoors();
  }, [buildingId, page]);

  const getPages = () => {
    const maxVisible = 5;
    let start = Math.max(1, page - Math.floor(maxVisible / 2));
    let end = start + maxVisible - 1;

    if (end > totalPages) {
      end = totalPages;
      start = Math.max(1, end - maxVisible + 1);
    }

    const pages = [];
    for (let i = start; i <= end; i++) {
      pages.push(
        <PaginationItem active={i === page} key={i}>
          <PaginationLink onClick={() => setPage(i)}>{i}</PaginationLink>
        </PaginationItem>,
      );
    }
    return pages;
  };

  return (
    <div>
      <div className="mb-3 d-flex justify-content-between align-items-center">
        <h2 className="mb-0">Monitoreo Puertas Abiertas</h2>

        <button type="button" className="btn d-flex align-items-center" onClick={getEventOpenDoors}>
          <span className="material-icons">refresh</span>
          <span className="ms-2">Refrescar</span>
        </button>
      </div>

      <EventOpenDoorList eventOpenDoors={eventOpenDoors} />

      <div className="mt-3 d-flex justify-content-center">
        <Pagination className="mb-0" size="sm">
          <PaginationItem disabled={page <= 1}>
            <PaginationLink previous onClick={() => setPage(page - 1)} />
          </PaginationItem>

          {getPages()}

          <PaginationItem disabled={page >= totalPages}>
            <PaginationLink next onClick={() => setPage(page + 1)} />
          </PaginationItem>
        </Pagination>
      </div>
    </div>
  );
};

EventOpenDoorMonitor.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      buildingId: PropTypes.string,
    }),
  }),
};

export default EventOpenDoorMonitor;
